import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags/fg';

export const RequestResolverLogo = (): React.ReactNode => {
	if (fg('request_resolver_logo_redesigned')) {
		return (
			<svg
				width="24"
				height="24"
				viewBox="0 0 48 52"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M21.049 0.790295C22.8749 -0.263431 25.1245 -0.263432 26.9504 0.790294L44.1581 10.7209C45.984 11.7746 47.1087 13.722 47.1087 15.8294V35.6906C47.1087 37.798 45.984 39.7454 44.1581 40.7991L26.9504 50.7297C25.1245 51.7834 22.8749 51.7834 21.049 50.7297L3.84132 40.7991C2.01542 39.7454 0.890625 37.798 0.890625 35.6906V15.8294C0.890625 13.722 2.01542 11.7746 3.84132 10.7209L21.049 0.790295Z"
					fill="#FFC716"
				/>
				<g clip-path="url(#clip0_134590_6043)">
					<path
						d="M25.5 19.0098L27.7545 19.0098V16.0098H20.2456L20.2456 19.0098L22.5 19.0098V20.6458C18.6598 21.3512 15.75 24.7157 15.75 28.7598V29.5098H32.25V28.7598C32.25 24.7157 29.3402 21.3512 25.5 20.6458V19.0098Z"
						fill="#101214"
					/>
					<path d="M33.75 31.7598V34.7598L14.25 34.7598V31.7598L33.75 31.7598Z" fill="#101214" />
				</g>
				<defs>
					<clipPath id="clip0_134590_6043">
						<rect width="36" height="36" fill="white" transform="translate(6 7.75977)" />
					</clipPath>
				</defs>
			</svg>
		);
	}
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11.0157 0.460898C11.6314 0.105482 12.3923 0.105482 13.013 0.460898L21.523 5.35163C22.1437 5.70705 22.5292 6.37283 22.5292 7.08867V16.8551C22.5292 17.571 22.1437 18.2317 21.523 18.5922L13.013 23.4829C12.3973 23.8383 11.6364 23.8383 11.0157 23.4829L2.50569 18.5871C1.88496 18.2317 1.49951 17.566 1.49951 16.8501V7.08366C1.49951 6.36782 1.88496 5.70705 2.50569 5.34663L11.0157 0.460898Z"
				fill="#FFC716"
			/>
			<path
				d="M3.84986 14.7098C4.04289 15.1401 4.56794 14.9528 4.49615 14.5108C4.3848 13.8824 4.27309 13.2334 4.15956 12.4036C4.02236 11.466 3.91148 11.2263 3.94069 10.581C3.96068 10.0367 4.10395 9.31419 4.32702 8.71544C4.54396 8.11316 4.84457 7.6491 4.96916 7.47579C5.00715 7.42416 5.03417 7.37027 5.06603 7.3151C5.17446 7.1202 5.47274 6.5894 6.00994 6.04123C6.54231 5.49435 7.32845 4.94685 8.13515 4.61149C9.26573 4.11162 10.0514 3.96848 10.4373 3.88063C11.3715 3.69249 12.0695 3.6091 12.774 3.5499C13.1561 3.52525 13.2294 3.04438 12.8197 2.94685C12.0727 2.78942 11.2733 2.76522 10.2578 2.95959C9.86454 3.03906 9.00911 3.07652 7.88492 3.52286C7.70282 3.59756 7.52461 3.68677 7.36125 3.79274C6.64141 4.23955 5.87177 4.82928 5.33811 5.37132C5.07305 5.63928 4.85988 5.88815 4.71112 6.06794C4.56849 6.25126 4.48898 6.36067 4.48898 6.36067C4.48898 6.36067 3.99383 7.02714 3.64767 7.95945C3.2844 8.88598 3.13745 10.0396 3.1331 10.7196C3.11627 11.7399 3.20455 12.2241 3.23748 12.5211C3.36915 13.4186 3.58084 14.0927 3.85824 14.7024L3.84986 14.7098Z"
				fill="#FFE48F"
			/>
			<path
				d="M19.5854 8.44686C19.3437 8.00893 18.8364 8.24332 18.9582 8.69784C19.1209 9.34352 19.2974 10.0218 19.4832 10.8893C19.6988 11.868 19.8268 12.1135 19.8492 12.7968C19.8686 13.372 19.787 14.1506 19.5988 14.8021C19.4168 15.4573 19.1449 15.9706 19.0365 16.1655C18.9998 16.222 18.9741 16.2807 18.9435 16.3407C18.8512 16.5572 18.5769 17.1386 18.0468 17.7522C17.5216 18.3645 16.722 18.9778 15.8822 19.3635C14.7078 19.9321 13.8874 20.1002 13.4773 20.1945C12.4973 20.4053 11.758 20.4893 11.0122 20.5492C10.6095 20.5742 10.5363 21.0551 10.9714 21.151C11.7596 21.3077 12.6003 21.3312 13.6761 21.1104C14.0861 21.016 14.9935 20.9595 16.1663 20.4431C16.3567 20.361 16.5359 20.256 16.7112 20.1364C17.4532 19.637 18.2398 18.9754 18.7663 18.3679C19.2928 17.7604 19.5879 17.2564 19.5879 17.2564C19.5879 17.2564 19.6162 17.2073 19.6609 17.1228C19.7105 17.037 19.7813 16.9143 19.854 16.7601C20.0152 16.4526 20.191 16.0065 20.3368 15.5061C20.6381 14.5029 20.694 13.2804 20.6493 12.5721C20.5838 11.4961 20.4552 10.9968 20.3978 10.6857C20.1938 9.75047 19.9151 9.05817 19.5877 8.43589L19.5854 8.44686Z"
				fill="#FFE48F"
			/>
			<path
				d="M18.0742 17.1757H5.49988V15.1554H18.0742V17.1757ZM13.882 7.01954H12.784V7.854H13.2406C15.5456 7.854 16.9822 10.0871 17.2368 12.3781L18.0742 13.9257C13.8915 13.9257 9.68254 13.9257 5.49988 13.9257L6.31097 12.3781C6.56552 10.0871 8.00215 7.854 10.3072 7.854H10.7637V7.01954H9.66577V5.49927H13.882V7.01954Z"
				fill="#101214"
			/>
			<path
				d="M12.7729 7.82959H13.23C15.5349 7.8296 16.9714 10.0622 17.2261 12.353L17.3052 12.4985H6.22412L6.30029 12.353C6.55495 10.0623 7.99159 7.8297 10.2964 7.82959H10.7534V6.99854H12.7729V7.82959Z"
				fill="white"
			/>
		</svg>
	);
};
